import {
  Biotech,
  EditNote,
  MonetizationOn,
  NoteAdd,
  Style,
  SupervisorAccount,
} from '@mui/icons-material';
import AdminPanelSettings from '@mui/icons-material/AdminPanelSettings';
import TuneIcon from '@mui/icons-material/Tune';
import {
  Box,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from '@mui/material';
import React from 'react';
import type { Item } from '~/components/AppHeader/types';
import { FeatureOverridesModal } from '~/components/FeatureOverridesModal';
import { Link } from '~/components/Link';

export const adminMenuItems: Item[] = [
  {
    href: '/admin/create_report',
    title: 'Create Report',
    icon: () => <NoteAdd />,
  },
  {
    href: '/admin/reports',
    title: 'Manage Report',
    icon: () => <EditNote />,
  },
  {
    href: '/admin/spend',
    title: 'Tech Spend',
    icon: () => <MonetizationOn />,
  },
  {
    href: '/admin/categories',
    title: 'Categories',
    icon: () => <AdminPanelSettings />,
  },
  {
    href: '/admin/accounts',
    title: 'Accounts',
    icon: () => <SupervisorAccount />,
  },
  {
    href: '/admin/domain-tags',
    title: 'Domain Tags',
    icon: () => <Style />,
  },
  {
    href: '/admin/crawl/bulk',
    title: 'Crawl Bulk',
    icon: () => <Biotech />,
  },
];

export const AdminMenu = () => {
  const [menuElement, setMenuElement] = React.useState<null | HTMLElement>(
    null
  );
  const [featureOverridesOpen, setFeatureOverridesOpen] = React.useState(false);

  const onMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMenuElement(event.currentTarget);
  };

  const onMenuClose = () => {
    setMenuElement(null);
  };

  const onFeatureOverridesOpen = () => {
    onMenuClose();
    setFeatureOverridesOpen(true);
  };

  const onFeatureOverridesClose = () => {
    setFeatureOverridesOpen(false);
  };

  return (
    <Box sx={{ flexGrow: 0 }}>
      <Tooltip title="Admin Menu">
        <IconButton onClick={onMenuOpen} sx={{ my: 2 }} size="large">
          <AdminPanelSettings fontSize="large" style={{ color: 'white' }} />
        </IconButton>
      </Tooltip>
      <Menu
        sx={{ mt: '45px' }}
        anchorEl={menuElement}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(menuElement)}
        onClose={onMenuClose}>
        {adminMenuItems.map((item) => {
          return (
            <MenuItem
              onClick={onMenuClose}
              href={item.href}
              key={item.href}
              component={Link}
              LinkComponent={(props) => (
                <Link
                  {...props}
                  href={item.href}
                  underline="none"
                  key={item.href}
                />
              )}>
              <ListItemIcon>
                <item.icon />
              </ListItemIcon>
              <ListItemText>{item.title}</ListItemText>
            </MenuItem>
          );
        })}
        <MenuItem onClick={onFeatureOverridesOpen}>
          <ListItemIcon>
            <TuneIcon />
          </ListItemIcon>
          <ListItemText>Feature Overrides</ListItemText>
        </MenuItem>
      </Menu>
      <FeatureOverridesModal
        open={featureOverridesOpen}
        onClose={onFeatureOverridesClose}
      />
    </Box>
  );
};
